import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicFormComponent } from 'app/_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { Globals } from 'app/_globals';
import { TrainingCourseState } from 'app/_models/training/training-course-state';
import { AssetTypesService } from 'app/_services/asset-types.service';
import { ContractorService } from 'app/_services/contractor.service';
import { NotificationService } from 'app/_services/notification.service';
import { RolePermissionService, SkylarkPermission } from 'app/_services/role-permission.service';
import { SiteSessionsService } from 'app/_services/site-sessions.service';
import { SiteWorkersService } from 'app/_services/site-workers.service';
import { SiteService } from 'app/_services/site.service';
import { TrainingCertService } from 'app/_services/training-cert.service';
import { environment } from 'environments/environment';
import { SortEvent } from 'primeng/api';
import Swal from 'sweetalert2';
import { AssignTrainingModalComponent } from './assign-training-modal/assign-training-modal.component';
import { ResendInductionReminderModalComponent } from './resend-induction-reminder-modal/resend-induction-reminder-modal.component';
import { TrainingService } from 'app/_services/training.service';
import { TrainingType } from 'app/_models/training/training-type';
import { InviteUsersService } from 'app/_services/invite-users.service';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { CompetencyService } from 'app/_services/competency.service';
import { CompetencyStatus, UserCompetency, WorkerSiteCompetencyCounts } from 'app/_models/competency.model';


@Component({
  selector: 'app-site-workers',
  templateUrl: './site-workers.component.html',
})
export class SiteWorkersComponent implements OnInit {
  selectedSite: any;
  selectedSiteId: any;
  siteWorkers: any[] = [];
  inductionData: any;
  public readonly huntstownSiteId = environment.HUNTSTOWN_ID;

  routeRole: any;
  public columnOptionsSidebarVisible: boolean;

  public TrainingCourseStateType = TrainingCourseState; // allow enum in template

  public togglableColumns = [
    { displayName: 'Username', default: false },
    { displayName: 'Phone', default: false },
    { displayName: 'Company', default: true },
    { displayName: 'Competencies', default: true },
    { displayName: 'Asset Categories', default: true },
    { displayName: 'Guests Permitted', default: true },
    { displayName: 'Site Session Permitted', default: true },
    { displayName: 'Site Delegate', default: true },
    // also added manually: { displayName: 'Induction', default: true }
  ];

  public togglableColumnsPowerStation = [
    { displayName: 'Username', default: false },
    { displayName: 'Phone', default: false },
    { displayName: 'Company', default: true },
    { displayName: 'Competencies', default: true },
    { displayName: 'Asset Categories', default: true },
    // also added manually: { displayName: 'Induction', default: true }
  ];

  // table options
  public tableOptions = {
    visibleColumns: [],
  }

  @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

  // pagination
  pageSizes: any = environment.pageSizes;
  pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  // Sorting and Filtering
  defaultSortField = 'workerUser.skylarkUser.user.lastName';
  selectedSort = [ this.defaultSortField + ',asc' ];

  public isFilterLoading: boolean;
  private filters = [
    { key: 'company', value: '' },
    { key: 'firstName', value: '' },
    { key: 'lastName', value: '' },
    { key: 'phoneNumber', value: '' },
  ];
  private huntstownCompetencyRequestId = 0;

  public competencyCountsByUser = new Map<string, WorkerSiteCompetencyCounts>();
  public huntstownCompetenciesByUser = new Map<string, Array<{
    label: string;
    badgeClass: string;
    textDetail: string;
    expiryDate?: string | Date;
  }>>();

  selectedContractor: any = null;
  contractors: any[] = [];
  companyWorkers: any[] = [];
  selectedContractorWorker: any = null;
  siteTypeAssetCategories: any[] = [];

  addExistingWorkerModal = false;
  addExistingWorkerForm: FormGroup;

  editSiteWorkerModal = false;
  editSiteWorkerForm: FormGroup;
  selectedSiteWorker: any;

  isFormBeingSubmitted = false;

  checkOutModal = false;

  workOrders: any[] = [];

  public hasInduction = false;
  minDate: Date = new Date();
  defaultCODate: Date;
  public currentlyAvailable: boolean;
  public hideGuestCheckbox: boolean;
  public hideSiteSessionsCheckbox: boolean;

  public isPowerStationView: boolean;
  public isPowerStationAdminView: boolean;
  public isPowerStationReadOnlyView: boolean;
  public isWindFarmView: boolean;
  public isAdmin: boolean;
  public isRegionalManager: boolean;
  public isSiteDelegate: boolean;

  public latestOutage: any;
  public totalResponsesNeeded: number;
  public groupedResponses: {} = {};

  // Skeleton loading
  public loading: boolean = true;

  constructor(
    private siteService: SiteService,
    private siteWorkersService: SiteWorkersService,
    private activatedRoute: ActivatedRoute,
    private contractorService: ContractorService,
    private router: Router,
    private assetTypesService: AssetTypesService,
    private notificationService: NotificationService,
    private siteSessionsService: SiteSessionsService,
    private trainingCertService: TrainingCertService,
    private modalService: NgbModal,
    private rolePermissionService: RolePermissionService,
    private trainingService: TrainingService,
    private inviteUsersService: InviteUsersService,
    private competencyService: CompetencyService,
    globals: Globals,
    fb: FormBuilder,
  ) {
    // Get SiteId from Params
    this.activatedRoute.params.subscribe((params: Params) => {
      this.selectedSiteId = params.id;
    });

    this.defaultCODate = new Date();
    this.defaultCODate.setHours(this.defaultCODate.getHours()+3);
    this.routeRole = globals.user.routeRole;
    this.isRegionalManager = globals.user.role === 12;
    this.isAdmin = this.routeRole === 'admin' || this.routeRole === 'support';
    this.isSiteDelegate = this.routeRole === 'site-delegate';

    this.isPowerStationView = this.rolePermissionService.hasPermission(SkylarkPermission.READ__POWER_STATION__WORKERS) && !this.isAdmin;

    this.isWindFarmView = !this.isPowerStationView;

    this.isPowerStationAdminView = this.rolePermissionService.hasPermission(SkylarkPermission.WRITE__POWER_STATION__ADMIN_DETAILS);
    this.isPowerStationReadOnlyView = this.isPowerStationView && !this.isPowerStationAdminView;

    this.addExistingWorkerForm = fb.group({
      assetCategories: new FormControl([], [Validators.required]),
      guestsPermitted: new FormControl(false, [Validators.required]),
      managementDuty: new FormControl(true, [Validators.required]),
    });

    this.editSiteWorkerForm = fb.group({
      assetCategories: new FormControl([], [Validators.required]),
      guestsPermitted: new FormControl(false, [Validators.required]),
      managementDuty: new FormControl(false, [Validators.required]),
      siteDelegate: new FormControl(false, [Validators.required]),
    });
  }

  ngOnInit() {
    this.setupColumnOptions();
    this.resetPagination();

    this.getSelectedSite(this.selectedSiteId).subscribe(() => {
      this.initializeAddWorkerForm();
      this.getAllSiteWorkers();
      this.loadSecondarySiteData();
    });

    if (this.isPowerStationView) {
      this.getAllPowerStationOutages();
    }
  }

  private initializeAddWorkerForm() {
    this.addExistingWorkerForm.patchValue({
      assetCategories: [],
      guestsPermitted: false,
      managementDuty: true,
    });

    this.applyHiddenAddWorkerFieldRules();
  }

  private applyHiddenAddWorkerFieldRules(): void {
    this.hideGuestCheckbox = false;
    this.hideSiteSessionsCheckbox = false;

    if (this.selectedSite.siteOwner.id === environment.WFSO_OWNER_SKYLARK_ID) {
      this.addExistingWorkerForm.patchValue({
        guestsPermitted: false,
      });
      this.hideGuestCheckbox = true;
    }

    if (this.selectedSite.siteOwner.login === 'huntstown') {
      this.addExistingWorkerForm.patchValue({
        guestsPermitted: false,
        managementDuty: false,
      });
      this.hideGuestCheckbox = true;
      this.hideSiteSessionsCheckbox = true;
    }
  }

  private clearSelectedWorker(): void {
    this.selectedContractorWorker = null;
    this.companyWorkers = [];
  }

  private resetAfterWorkerAdded(): void {
    this.selectedContractorWorker = null;
  }

  // Get SelectedSite
  public getSelectedSite(siteid): Observable<any> {
    return this.siteService.getSiteById(siteid).pipe(tap((data: any) => {
      this.selectedSite = data;

      this.hasInduction = !!this.selectedSite.siteInductionCourse;
      this.inductionData = this.selectedSite.siteInductionCourse;
    }));
  }

  public get isHuntstownSite(): boolean {
    return Number(this.selectedSiteId) === Number(this.huntstownSiteId);
  }

  public get showHuntstownCompetencyColumn(): boolean {
    return this.isHuntstownSite && this.isPowerStationAdminView;
  }

  // Get All Workers for site
  public getAllSiteWorkers() {
    this.loading = true;

    this.siteWorkersService.getAllWorkerForSiteWithFilters(this.selectedSiteId, this.pagination, this.selectedSort, this.filters)
    .pipe(finalize(() => setTimeout(() => { this.loading = false; }, 500)))
    .subscribe((data: any) => {
      this.siteWorkers = data.body;

      this.siteWorkers.forEach(worker => {
        worker.isSendingInductionReminder = false;
        worker.inductionReminderSent = false;
        worker.huntstownCompetencies = [];
      });

      this.loadCompetencyCounts(this.siteWorkers);

      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
      this.isFilterLoading = false;
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error retrieving worker list');
      this.isFilterLoading = false;
    });
  }

  public getAllContractors(siteOwnerId) {

    if (this.isPowerStationReadOnlyView) {
      return;
    }

    this.contractorService.getLinkedContractors(siteOwnerId, ({ size: 999, page: 0 }), 'name,asc', undefined).subscribe(
      (data: any) => {
        this.contractors = [];
        data.body.forEach((element) => {
          const item = {
            label: element.name,
            value: element,
          };
          this.contractors.push(item);
        });
      },
      (error) => {
        console.error(error);
        this.notificationService.notify('danger', 'Error', 'Error retrieving contractor list. Add Worker is unavailable');
      });
  }

  // Get all asset types for site type
  public getAllAssetTypesForSiteType(siteTypeId) {
    if (this.isPowerStationReadOnlyView) {
      return;
    }
    this.assetTypesService.getAllAssetTypesForSiteType(siteTypeId).subscribe(
      (data: any) => {
        this.siteTypeAssetCategories = [];
        data.forEach((element) => {
          const obj = {
            label: element.name,
            value: element.id,
          };
          this.siteTypeAssetCategories.push(obj);
        });
      },
      (error) => {
        console.error(error);
        this.notificationService.notify('danger', 'Error', 'Could not load asset types for this site. Add Worker is unavailable');
      }
    );
  }

  // Adding Workers
  public toggleAddWorkerModal() {
    this.addExistingWorkerModal = !this.addExistingWorkerModal;
    this.isFormBeingSubmitted = false;
  }

  // Handle Selection of Contractor
  public onSelectedContractorChange(event) {
    if (event && event.value !== null) {
      this.selectedContractor = event;
      this.clearSelectedWorker();
      this.getWorkersForSelectedCompany(event.value.id);
    } else {
      this.selectedContractor = null;
      this.clearSelectedWorker();
    }
  }

  // Get Workers for selected company
  public getWorkersForSelectedCompany(id) {
    this.contractorService.getWorkerListForContractor(id, false).subscribe(
      (data: any) => {
        const hasWorkers = data
        if (hasWorkers.length === 0) {
          this.notificationService.notify('danger', 'No workers are currently set up for this contractor.');
        }

        this.companyWorkers = [];
        data.forEach((element) => {
          const item = {
            label: element.firstName + ' ' + element.lastName,
            value: element,
          };
          this.companyWorkers.push(item);
        });
      },
      (error) => {
        console.error(error);
        this.notificationService.notify('danger', 'Error retrieving workers list');
      });
  }

  // Handle Selection of Worker
  public onSelectedContractorWorkerChange(event) {
    this.selectedContractorWorker = event || null;
    this.applyHiddenAddWorkerFieldRules();
  }

  // Handle Add Worker Form Submit
  public onAddExistingWorkerFormSubmit() {
    if (!this.selectedContractorWorker || !this.addExistingWorkerForm.valid) {
      return;
    }

    this.isFormBeingSubmitted = true;

    const values = this.addExistingWorkerForm.value;
    const body = {
      assetCategoryIds: values.assetCategories.map(item => item.value),
      guestsPermitted: values.guestsPermitted,
      managementDuty: values.managementDuty,
      siteId: this.selectedSiteId,
      skylarkUserId: this.selectedContractorWorker.value.skylarkUserId,
    };
    this.siteWorkersService.addWorkerToSite(body).subscribe((data: any) => {
      this.getAllSiteWorkers();
      // on success, keep most of the values so it's easy to add the next worker from the same company
      this.resetAfterWorkerAdded();
      this.addExistingWorkerModal = false;
      this.isFormBeingSubmitted = false;
      this.notificationService.notify('success', 'Worker Added', 'Worker has successfully been added.');
    }, error => {
      console.error(error);

      this.isFormBeingSubmitted = false;
      this.notificationService.notify('danger', 'Error', error && error.error && error.error.title ? error.error.title : 'Server error adding worker');
    });
  }

  // Handle Pagination
  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;

    this.getAllSiteWorkers();
  }

  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();
  }

  private loadSecondarySiteData(): void {
    this.getAllAssetTypesForSiteType(this.selectedSite.siteType.id);
    this.getAllContractors(this.selectedSite.siteOwner.id);
  }

  // Handle onRowSelect of a user
  public async onRowSelect(event) {
    if (this.isPowerStationReadOnlyView) {
      return;
    }
    this.selectedSiteWorker = event.data;
    const hasValidInduction = this.selectedSiteWorker.inductionForSite && this.selectedSiteWorker.inductionForSite.courseProgress === TrainingCourseState.Completed;
    const isDownloadCertToBeShown = this.trainingCertService.shouldSendCertificatePdf([this.selectedSiteId]) && hasValidInduction;
    const canCheckOn = this.isWindFarmView && (!this.hasInduction || hasValidInduction);

    const { value: action } = await Swal.fire({
      titleText: event.data.workerUser.firstName + ' ' + event.data.workerUser.lastName,
      input: 'select',
      inputOptions: {
        ...(this.isWindFarmView && { edit: 'Edit' }),
        delete: 'Remove from site',
        ...(this.isPowerStationAdminView && !this.isAdmin && { competencyAndRequirements: 'Manage Competencies' }),
        ...(this.isWindFarmView && { competencyWindFarm: 'Manage Competencies' }),
        ...(isDownloadCertToBeShown && { downloadCertificate: 'Download Certificate'}),
        assignTraining: 'View/Assign Training Courses',
        ...(canCheckOn && { checkin: 'Check in to Work Order / Site Session' }),
        ...(canCheckOn && { checkout: 'Check out of Work Order' }),
      },
      inputPlaceholder: 'Select an option',
      showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          resolve(null);
        });
      },
    });

    if (action) {
      if (action === 'edit') {
        this.toggleEditSiteWorkerModal();
      } else if (action === 'delete') {
        this.deleteWorker();
      } else if (action === 'competencyAndRequirements') {
        this.router.navigate(
          ['/' + this.routeRole + '/workers/' + this.selectedSiteWorker.workerUser.id + '/manage-competencies'],
          { queryParams: { backLink:  `/${this.routeRole}/sites/${this.selectedSite.id}/workers`, siteOwnerId: this.selectedSite.siteOwner.id } }
        );
      } else if (action === 'competencyWindFarm') {
        this.router.navigate(
          ['/' + this.routeRole + '/workers/' + this.selectedSiteWorker.workerUser.id + '/manage-competencies'],
          { queryParams: { backLink:  `/${this.routeRole}/sites/${this.selectedSite.id}/workers`, siteOwnerId: this.selectedSite.siteOwner.id } }
        );
      } else if (action === 'downloadCertificate') {
        this.downloadCertificate();
      } else if (action === 'assignTraining') {
        this.assignTraining();
      } else if (action === 'checkin') {
        this.checkinWorker();
      } else if (action === 'checkout') {
        this.checkoutWorker();
      } else {
        console.log('No valid option selected');
      }
    }
  }

  private assignTraining() {
    const modalRef = this.modalService.open(AssignTrainingModalComponent, { centered: true });
    modalRef.componentInstance.worker = this.selectedSiteWorker;
    modalRef.componentInstance.siteOwnerId = this.selectedSite.siteOwner.id;
  }

  public checkinWorker() {
    localStorage.setItem('temp.data.checkInWorker', JSON.stringify(this.selectedSiteWorker));

    this.router.navigate(
      ['/' + this.routeRole + '/sites/' + this.selectedSite.id + '/check-in'],
      { queryParams: { workerId:  this.selectedSiteWorker.id } }
    );
  }

  public checkoutWorker() {
    this.siteSessionsService.checkIfUserInSession(this.selectedSiteWorker.workerUser.id).subscribe((data: any) => {
      if (!data.length) {
        Swal.fire('Warning', 'Worker is not on any active session!', 'warning');
      } else {
        const body = {
          siteSessionId: data[0].siteSession.id,
          workerUserId: this.selectedSiteWorker.workerUser.id,
        };
        if (data[0].workerOrder === null) {
          // Check out management
          this.siteSessionsService.checkOutManager(body).subscribe((rData: any) => {
            Swal.fire('Success', 'Worker checked out!', 'success');
          });
        } else {
          // Check out normal
          this.siteSessionsService.checkOut(body).subscribe((rData: any) => {
            Swal.fire('Success', 'Worker checked out!', 'success');
          });
        }
      }
    });
  }

  private downloadCertificate() {
    const expiryDate = new Date(this.selectedSiteWorker.inductionForSite.expiryDate);
    let startDate = new Date(this.selectedSiteWorker.inductionForSite.expiryDate);
    startDate.setMonth(expiryDate.getMonth() - this.inductionData.validForMonths);

    let certificateDetails = {
      workerName: this.selectedSiteWorker.workerUser.firstName + ' ' + this.selectedSiteWorker.workerUser.lastName,
      company: this.selectedSiteWorker.workerUser.workerUser.maintenance.name,
      inductionName: this.inductionData.name,
      siteName: this.selectedSite.name,
      startDate: startDate,
      expiryDate: expiryDate,
    };

    this.trainingCertService.downloadPdfCert(certificateDetails, this.selectedSite.id);
  }

  public toggleEditSiteWorkerModal() {
    this.editSiteWorkerModal = !this.editSiteWorkerModal;
    this.assignEditFormValues();
    this.isFormBeingSubmitted = false;
  }

  public assignEditFormValues() {
    this.editSiteWorkerForm.patchValue({
      guestsPermitted: this.selectedSiteWorker.guestsPermitted,
      managementDuty: this.selectedSiteWorker.managementDuty,
      siteDelegate: this.selectedSiteWorker.siteDelegate,
      assetCategories: this.selectedSiteWorker.assetCategories.map(item => { return { label: item.name, value: item.id }; })
    });
  }

  public onEditSiteWorkerFormSubmit() {
    this.isFormBeingSubmitted = true;

    const values = this.editSiteWorkerForm.value;
    const body = {
      assetCategoryIds: values.assetCategories.map(item => item.value),
      guestsPermitted: values.guestsPermitted,
      managementDuty: values.managementDuty,
      siteDelegate: values.siteDelegate,
      id: this.selectedSiteWorker.id,
    };
    this.siteWorkersService.editSiteWorker(body).subscribe((data: any) => {
      this.getAllSiteWorkers();
      this.editSiteWorkerForm.reset();
      this.toggleEditSiteWorkerModal();
      this.isFormBeingSubmitted = false;
      this.notificationService.notify('success', 'Worker Updated', 'Worker has successfully been updated.', 'top', 'right');
    }, (error) => {
      console.error(error);
      this.isFormBeingSubmitted = false;
      this.notificationService.notify('danger', 'Error', 'Could not update worker');
    });
  }

  public deleteWorker() {
    Swal.fire({
      title: 'Remove Worker from Site?',
      text: 'This will prevent worker from accessing your site!',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, remove',
    }).then((result) => {
      if (result.value) {
        this.siteWorkersService.removeWorkerFromSite(this.selectedSiteWorker.id).subscribe(
          (data: any) => {
            this.getAllSiteWorkers();
            Swal.fire('Removed!', 'Worker has been removed.', 'success');
          },
          (error) => {
            console.error(error);
            this.notificationService.notify('danger', 'Error', 'Could not remove worker from site');
          }
        );
      }
    });
  }

  public customSort(sort: SortEvent) {
    let sortDirection: String = 'asc';

    if (sort.order === -1) {
      sortDirection = 'desc';
    }
    this.selectedSort = [ sort.field + ',' + sortDirection ];

    this.goToFirstPage();

    this.getAllSiteWorkers();
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }

  public resetColumnOptions() {
    const defaultColumns = this.isPowerStationView ? this.togglableColumnsPowerStation : this.togglableColumns;

    this.tableOptions = {
      visibleColumns: defaultColumns.filter(col => col.default).map(col => col.displayName),
    };
    this.tableOptions.visibleColumns.push('Induction');

    this.saveTableOptions();
  }

  public saveTableOptions() {
    localStorage.setItem('ui.options.siteWorkers', JSON.stringify(this.tableOptions));
  }

  public setupColumnOptions() {
    const savedOptions = localStorage.getItem('ui.options.siteWorkers');

    if (savedOptions) {
      this.tableOptions = JSON.parse(savedOptions);
      const defaultColumns = this.isPowerStationView ? this.togglableColumnsPowerStation : this.togglableColumns;
      defaultColumns
        .filter(col => col.default && !this.tableOptions.visibleColumns.includes(col.displayName))
        .forEach(col => this.tableOptions.visibleColumns.push(col.displayName));
      this.saveTableOptions();
    } else {
      this.resetColumnOptions();
    }
  }

  public onFilterTextChanged(filterText: string, filterField: string){
    this.isFilterLoading = true;

    this.filters.find(filter => filter.key === filterField).value = filterText;

    this.getAllSiteWorkers();
  }

  public hasReliableCompetencyCounts = false;
  public hasReliableHuntstownCompetencies = false;

  public get addWorkerButtonDisabled(): boolean {
    return this.siteTypeAssetCategories.length === 0 || this.contractors.length === 0;
  }

  public getCompetencyCountLabel(worker: any): string {
    const counts = this.getCompetencyCounts(worker);
    const total = counts
      ? counts.approvedCount + counts.expiredCount + counts.rejectedCount + counts.pendingCount
      : 0;
    return `${total} ${total === 1 ? 'Competency' : 'Competencies'}`;
  }

  public getCompetencyStatusItems(worker: any): Array<{ count: number; label: string; colorClass: string }> {
    const counts = this.getCompetencyCounts(worker);
    if (!counts) {
      return [];
    }
    return [
      { count: counts.approvedCount, label: 'Approved', colorClass: 'text-success' },
      { count: counts.expiredCount, label: 'Expired', colorClass: 'text-danger' },
      { count: counts.rejectedCount, label: 'Rejected', colorClass: 'text-danger' },
      { count: counts.pendingCount, label: 'Pending', colorClass: 'text-warning' },
    ].filter(item => item.count > 0);
  }

  private loadCompetencyCounts(workers: any[]): void {
    if (this.showHuntstownCompetencyColumn) {
      this.loadHuntstownCompetencies(workers);
    }

    const siteOwnerUserId = this.selectedSite.siteOwner.siteOwnerUser.skylarkUserId;

    const skylarkUserIds = workers
      .map(worker => this.getWorkerSkylarkUserId(worker))
      .filter(id => id !== null);

    if (!skylarkUserIds.length) {
      this.competencyCountsByUser.clear();
      this.hasReliableCompetencyCounts = workers.length === 0;
      return;
    }

    this.hasReliableCompetencyCounts = false;

    this.competencyService.getCompetencyCountsForSite(skylarkUserIds, this.selectedSiteId, siteOwnerUserId)
      .subscribe((rows) => {
        this.competencyCountsByUser.clear();
        rows.forEach((row) => {
          this.competencyCountsByUser.set(String(row.skylarkUserId), row);
        });
        this.hasReliableCompetencyCounts = true;
      }, () => {
        this.hasReliableCompetencyCounts = false;
        this.notificationService.notify('danger', 'Error', 'Could not load competency data');
      });
  }

  private loadHuntstownCompetencies(workers: any[]): void {
    const requestId = ++this.huntstownCompetencyRequestId;
    const siteOwnerUserId = this.selectedSite.siteOwner.siteOwnerUser.skylarkUserId;

    // get worker ids from table, reset their competencies cell
    const skylarkUserIds = workers
      .map(worker => this.getWorkerSkylarkUserId(worker))
      .filter(id => id !== null);

    if (!skylarkUserIds.length) {
      if (requestId !== this.huntstownCompetencyRequestId) {
        return;
      }
      this.huntstownCompetenciesByUser.clear();
      workers.forEach((worker) => {
        worker.huntstownCompetencies = [];
      });
      this.hasReliableHuntstownCompetencies = workers.length === 0;
      return;
    }

    this.hasReliableHuntstownCompetencies = false;

    // call comp api to get workers competency data
    this.competencyService.searchUserCompetencyStatus(skylarkUserIds, siteOwnerUserId)
      .subscribe((rows) => {
        if (requestId !== this.huntstownCompetencyRequestId) {
          return;
        }
        this.huntstownCompetenciesByUser.clear();

        rows.forEach((row) => {
          this.huntstownCompetenciesByUser.set(
            String(row.skylarkUserId),
            (row.competencies || [])
              .filter((competency) => competency.hasCompetencyApproval)
              .map((competency) => this.mapHuntstownCompetencyBadge(competency))
              .sort((left, right) => left.label.localeCompare(right.label))
          );
        });

        // add to each worker row
        workers.forEach((worker) => {
          const skylarkUserId = this.getWorkerSkylarkUserId(worker);
          worker.huntstownCompetencies = skylarkUserId
            ? (this.huntstownCompetenciesByUser.get(String(skylarkUserId)) || [])
            : [];
        });
        this.hasReliableHuntstownCompetencies = true;
      }, () => {
        if (requestId !== this.huntstownCompetencyRequestId) {
          return;
        }
        this.hasReliableHuntstownCompetencies = false;
        this.notificationService.notify('danger', 'Error', 'Could not load competency data');
      });
  }

  private mapHuntstownCompetencyBadge(competency: UserCompetency): {
    label: string;
    badgeClass: string;
    textDetail: string;
    expiryDate?: string | Date;
  } {
    const label = competency.shortName || competency.name;

    switch (competency.status) {
      case CompetencyStatus.Approved:
        return { label, badgeClass: 'badge-success', textDetail: 'valid until:', expiryDate: competency.expiryDate };
      case CompetencyStatus.DocumentSubmitted:
        return { label, badgeClass: 'badge-warning', textDetail: 'requires approval' };
      case CompetencyStatus.Unverified:
        return { label, badgeClass: 'badge-warning', textDetail: 'needs review' };
      case CompetencyStatus.Expired:
        return { label, badgeClass: 'badge-danger', textDetail: 'expired on:', expiryDate: competency.expiryDate };
      case CompetencyStatus.DocumentRequested:
        return { label, badgeClass: 'badge-danger', textDetail: 'evidence requested' };
      case CompetencyStatus.Rejected:
      default:
        return { label, badgeClass: 'badge-danger', textDetail: 'rejected' };
    }
  }

  private getCompetencyCounts(worker: any): WorkerSiteCompetencyCounts | null {
    const skylarkUserId = this.getWorkerSkylarkUserId(worker);
    if (!skylarkUserId) {
      return null;
    }
    return this.competencyCountsByUser.get(String(skylarkUserId)) || null;
  }

  private getWorkerSkylarkUserId(worker: any): number | null {
    if (!worker || !worker.workerUser) {
      return null;
    }

    const candidate =
      worker.workerUser.skylarkUserId
      || (worker.workerUser.workerUser && worker.workerUser.workerUser.skylarkUserId)
      || worker.workerUser.id;
    const skylarkUserId = Number(candidate);
    return Number.isFinite(skylarkUserId) && skylarkUserId > 0 ? skylarkUserId : null;
  }

  public getAllPowerStationOutages() {
    const fullPagination = { page: 0, size: 200000, totalRecords: 0 };

    this.trainingService.getAllTrainingCourses(fullPagination, ['createdDate,desc'], '', TrainingType.Outage).subscribe((response) => {
      if (response.body.length) {
        this.latestOutage = response.body[0];

        this.trainingService.getMaintenanceListByOutage(this.latestOutage.trainingId, fullPagination).subscribe((response) => {
          this.totalResponsesNeeded = response.totalRecords;

          this.groupedResponses = response.body.reduce((groupedResponses, response) => {
            const status = response.courseProgress;

            groupedResponses[status] += 1;
            return groupedResponses;
          }, {
            [TrainingCourseState.Completed]: 0,
            [TrainingCourseState.InProgress]: 0,
            [TrainingCourseState.NotStarted]: 0,
            [TrainingCourseState.Expired]: 0,
          });

        }, error => {
          console.error(error);
          this.notificationService.notify('danger', 'Error loading contractor responses to outages');
        });
      }
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error retrieving outages list');
    });
  }

  public goToOutageResponses(trainingId) {
    this.router.navigate(['/', this.routeRole, 'training', trainingId, 'contractors']);
  }

  public resendInvite(worker) {
    if (worker.isSendingInvite || worker.inviteSent) {
      return;
    }

    worker.isSendingInvite = true;

    this.inviteUsersService.resendInvite(worker.login).subscribe(
      (response) => {
        worker.isSendingInvite = false;
        worker.inviteSent = true;
        this.notificationService.notify('success', 'Invite resent to ' + worker.email);
      },
      (error) => {
        worker.isSendingInvite = false;
        this.notificationService.notify('danger', 'Error', 'Failed to resend invite to ' + worker.email);
      }
    );
  }

  public resendInductionReminder(worker) {
    if (worker.isSendingInductionReminder || worker.inductionReminderSent) {
      return;
    }

    const modalRef = this.modalService.open(ResendInductionReminderModalComponent, { centered: true, size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.workerFirstName = worker.workerUser.firstName;
    modalRef.componentInstance.siteName = this.selectedSite.name;
    modalRef.componentInstance.defaultMessage = `Please complete your induction for ${this.selectedSite.name} BEFORE arriving to site`;
    modalRef.componentInstance.skylarkUserId = worker.workerUser.id;
    modalRef.componentInstance.courseId = this.inductionData.id;
    modalRef.componentInstance.workerEmail = worker.workerUser.email || 'worker';

    modalRef.componentInstance.sendingStateChange.subscribe((isSending: boolean) => {
      worker.isSendingInductionReminder = isSending;
    });

    modalRef.componentInstance.reminderSent.subscribe(() => {
      worker.inductionReminderSent = true;
    });
  }

}
